import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FilePlus2, FileText, Trash2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LettersPanel = ({ letters, reload }) => {
  const remove = async (l) => {
    if (!window.confirm(`Delete the letter for ${l.patient_name}?`)) return;
    await axios.delete(`${API}/letters/${l.id}`, { withCredentials: true });
    reload();
  };
  return (
    <div data-testid="letters-panel" className="bg-white rounded-2xl border border-teal-50 overflow-hidden">
      <div className="flex items-center justify-between gap-3 p-5 border-b border-teal-50">
        <div>
          <h2 className="font-semibold text-teal-900">Consult summary letters</h2>
          <p className="text-xs text-slate-500">Letters for patients' local doctors, on the clinic letterhead.</p>
        </div>
        <Link data-testid="letters-new" to="/dashboard/letters/new" className="btn-coral inline-flex items-center gap-2 px-5 py-2.5 rounded-full font-semibold text-sm"><FilePlus2 size={16} /> New letter</Link>
      </div>
      {letters.length === 0 ? <p className="text-slate-500 p-8 text-center">No letters yet.</p> : letters.map((l) => (
        <div key={l.id} data-testid={`letter-row-${l.id}`} className="flex flex-wrap items-center justify-between gap-3 p-5 border-b border-teal-50 last:border-0">
          <Link to={`/dashboard/letters/${l.id}`} className="flex items-center gap-3 min-w-0 group">
            <span className="grid place-items-center w-10 h-10 rounded-xl bg-teal-50 text-teal-700 shrink-0"><FileText size={18} /></span>
            <span className="min-w-0">
              <span className="block font-semibold text-teal-900 group-hover:underline">{l.patient_name}{l.country && <span className="font-normal text-slate-500"> · {l.country}</span>}</span>
              <span className="block text-xs text-slate-500 truncate">{l.diagnosis || 'No diagnosis entered'} · {l.consult_date}</span>
            </span>
          </Link>
          <button data-testid={`letter-delete-${l.id}`} onClick={() => remove(l)} className="grid place-items-center w-9 h-9 rounded-full text-slate-400 hover:text-red-600 hover:bg-red-50 transition-colors" aria-label="Delete letter"><Trash2 size={16} /></button>
        </div>
      ))}
    </div>
  );
};
